import { render, staticRenderFns } from "./joinlist.vue?vue&type=template&id=49d366e6"
import script from "./joinlist.vue?vue&type=script&lang=js"
export * from "./joinlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports